export const chemistry12 = [
  {
    id: 'che121',
    image: require('../assets/images/simulation/che/12/KMnOsolution.jpg'),
    name: 'Determination of ferrous ion in an unknown solution using KMnO4.',
    title: 'Quantitative Chemistry - KMnO4',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che122',
    image: require('../assets/images/simulation/che/12/sodium-carbonate.jpg'),
    name: 'Determination of concentration of unknown HCl solution using 0.1M Na2CO3.',
    title: 'Quantitative Chemistry - Sodium Carbonate',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che123',
    image: require('../assets/images/simulation/che/12/oxalic-acid.jpg'),
    name: 'Determination of concentration of unknown NaOH solution using 0.5M Oxalic acid.',
    title: 'Quantitative Chemistry - Oxalic Acid',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che124',
    image: require('../assets/images/simulation/che/12/carbohydrate.jpg'),
    name: 'Functional group identification in supplied organic sample.',
    title: 'Organic Chemistry - Carbohydrate',
    route: '/chemistry-simulation-template',
  },
];

export const chemistry11 = [
  {
    id: 'che111',
    image: require('../assets/images/simulation/che/11/flame-test.jpg'),
    name: 'Identification of different metallic ions using flame test.',
    title: 'Qualitative Chemistry - Flame Test',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che112',
    image: require('../assets/images/simulation/che/11/chromatography.jpg'),
    name: 'Separation of compound from mixture using paper chromatography.',
    title: 'Chemical Changes - Chromatography',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che113',
    image: require('../assets/images/simulation/che/11/acid-base.jpg'),
    name: 'Determination of acid-base nature of soluble oxides of elements.',
    title: 'Qualitative Chemistry - Acid-Base',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che114',
    image: require('../assets/images/simulation/che/11/kelasan-method.jpg'),
    name: 'Preparation of pure salt crystals from impure sample using crystallization.',
    title: 'Chemical Changes - Crystallization',
    route: '/chemistry-simulation-template',
  },
];

export const chemistry10 = [
  {
    id: 'che101',
    image: require('../assets/images/simulation/che/10/litmus-paper.jpg'),
    name: 'Preparation of acid and base from food using Litmus paper and pH.',
    title: 'Acid Base Equillibrium - Litmus Paper',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che102',
    image: require('../assets/images/simulation/che/10/ammonia.jpg'),
    name: 'Observation of reaction changes of ammonia salt with base.',
    title: 'Chemical Reaction - Ammonia Salt',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che103',
    image: require('../assets/images/simulation/che/10/sodium-hydroxide.jpg'),
    name: 'Observation of changes by adding NaOH to two known salt solutions.',
    title: 'Chemical Reaction - Caustic Soda',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che104',
    image: require('../assets/images/simulation/che/10/carbonate-salt.jpg'),
    name: 'Experiment on reaction rate of carbonate salt with water and acid.',
    title: 'Chemical Reaction - Carbonate Salt',
    route: '/chemistry-simulation-template',
  },
];

export const chemistry09 = [
  {
    id: 'che091',
    image: require('../assets/images/simulation/che/09/degeneration.jpg'),
    name: 'Separation of two components from a mixture using sublimation.',
    title: 'Chemical Bonds - Sublimation',
    route: '/chemistry-simulation-template',
  },
  {
    id: 'che092',
    image: require('../assets/images/simulation/che/09/metallic-carbonate.jpg'),
    name: 'Gas identification by reaction of dilute acid with metallic carbonate.',
    title: 'Chemical Reaction - Gas Identification',
    route: '/chemistry-simulation-template',
  },
];
